import {
  PURCHASE_POINTS_BRAND_PATH,
  PURCHASE_POINTS_BRANDS_PATH,
  PURCHASE_POINTS_OFFER_PATH,
  PURCHASE_POINTS_PATH,
} from "@/features/purchasePoints/config/purchasePoints.config";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const PurchasePointsPage = lazyWithRetry(() => import("@/features/purchasePoints/pages/PurchasePointsPage"));
const PurchasePointsBrandsPage = lazyWithRetry(
  () => import("@/features/purchasePoints/pages/PurchasePointsBrandsPage"),
);
const PurchasePointsBrandPage = lazyWithRetry(
  () => import("@/features/purchasePoints/pages/PurchasePointsBrandPage"),
);
const PurchasePointsOfferPage = lazyWithRetry(
  () => import("@/features/purchasePoints/pages/PurchasePointsOfferPage"),
);

const purchasePointsRoutes: RouteConfig[] = [
  {
    path: PURCHASE_POINTS_PATH,
    element: <PurchasePointsPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: PURCHASE_POINTS_BRANDS_PATH,
    element: <PurchasePointsBrandsPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: PURCHASE_POINTS_BRAND_PATH,
    element: <PurchasePointsBrandPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: PURCHASE_POINTS_OFFER_PATH,
    element: <PurchasePointsOfferPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default purchasePointsRoutes;
